import { defineGameCard } from '../authoring/index.js';
export const MilitiaCard = defineGameCard({
    id: 'militia',
    gameplay: { type: 'UNIT', cost: 1, baseStats: { attack: 2, health: 2 } },
    presentation: {
        name: 'Ополченец',
        description: 'Обычный боец без дополнительных способностей.',
        glyph: {
            colors: ['#10213A', '#6B5F40', '#7C725E', '#B78D5C', '#4E4533'],
            rows: [
                '.........11.........',
                '........1221........',
                '.......133331.......',
                '......13333331......',
                '......14144141......',
                '......14444441......',
                '....115544442311....',
                '...15522222222331...',
                '..1522222222222331..',
                '..1221522222221231..',
                '..1221555222221221..',
                '..1221555555221221..',
                '..1441111111111441..',
                '..1441555552221441..',
                '...11155222222111...',
                '.....1522222221.....',
                '.....1222222221.....',
                '.....1551111551.....',
                '.....1551..1551.....',
                '......11....11......',
            ],
        },
    },
    role: 'playable',
});
//# sourceMappingURL=militia.js.map